// import trackApplyFilter from './trackApplyFilter.middleware';
import trackExpandPerformanceTarget from './trackExpandPerformanceTarget.middleware';
import trackScreenName from './trackScreenName.middleware';
import trackUserId from './trackUserId.middleware';
import trackUserProperties from './trackUserProperties.middleware';

export default [
  trackUserId,
  trackUserProperties,
  trackScreenName,
  trackExpandPerformanceTarget,
  // trackApplyFilter,
];
